var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 5 256 280",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1E81F7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.3404299,255.334258 C24.3404299,255.334258 -73.0918953,100.291201 127.341014,0.456539689 L127.341014,255.334258 L24.3404299,255.334258"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.372638,255.334258 L158.372638,97.3588866 C158.372638,97.3588866 190.363104,149.565235 255.376099,255.334258 L158.372638,255.334258"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSails);
export default __webpack_public_path__ + "static/media/sails.b9e96f58650fba8797d4a5796b7781e6.svg";
export { ForwardRef as ReactComponent };